const heatmapActionTypes = {
    SET_CONFIG:         'HEATMAP/SET_CONFIG',
    SET_DATA:           'HEATMAP/SET_DATA',
    SET_LOADING:        'HEATMAP/SET_LOADING',
    SET_CONFIG_LOADING: 'HEATMAP/SET_CONFIG_LOADING',
    SET_ERROR:          'HEATMAP/SET_ERROR',
    SET_INDEX:          'HEATMAP/SET_INDEX',
    SET_SECTOR:         'HEATMAP/SET_SECTOR',
    SET_GROUP_BY:       'HEATMAP/SET_GROUP_BY',
    SET_SIZE_BY:        'HEATMAP/SET_SIZE_BY',
    SET_COLOR_BY:       'HEATMAP/SET_COLOR_BY',
} as const

export default heatmapActionTypes
